export default {
  data() {
    return {
      // route 是否准备好
      routeReady: false,
    };
  },
  created() {
    this._watchRouteStatus();
  },
  mounted() {
    this._setTheme(window.document.documentElement);
  },
  methods: {
    /**
     * 监听响应式属性，为指定的DOM添加属性 data-site-theme="getTheme()"
     * @param {Function} getTheme
     * @param {DOM} ref 需要设置属性的 DOM 节点
     */
    _setTheme(ref) {
      this.$watch(
        '$route.meta.theme',
        () => {
          ref?.setAttribute(
            'data-site-theme',
            this.$route.meta.theme || 'light'
          );
        },
        {
          immediate: true,
        }
      );
    },
    // 监听 route 是否准备好
    _watchRouteStatus() {
      this.$watch(
        '$route',
        (to) => {
          if (!to.name || this.routeReady) return;
          this.routeReady = true;
        },
        {
          immediate: true,
        }
      );
    },
  },
};
